(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-promo"] && !Shopify.designMode) return;
  try {
    
  if (!Shopify.designMode || view_settings.place_blocks) {
    // append all videos to the grid
    const productGrid = document.querySelector('[data-products-wrapper]');
    const promos = document.querySelectorAll('[data-collection-promo]');
    promos.forEach(promo => {
      productGrid.append(promo);
    });

    // run the global function to place the items on the grid
    loadPromos();
  }

  } catch(e) { console.error(e); }
})();
})();
